export default __webpack_public_path__ + "static/media/hero-login-bg2.c1a18fe2.jpg";